var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10.6321C10.8641 10.6321 11.97 9.52622 11.97 8.16208C11.97 6.79793 10.8641 5.69208 9.5 5.69208C8.13586 5.69208 7.03 6.79793 7.03 8.16208C7.03 9.52622 8.13586 10.6321 9.5 10.6321Z",
    stroke: "#00a14b",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.86583 6.72126C4.42541 -0.134571 14.5825 -0.126655 16.1342 6.72918C17.0446 10.7508 14.5429 14.155 12.35 16.2608C10.7587 17.7967 8.24124 17.7967 6.64208 16.2608C4.45708 14.155 1.95541 10.7429 2.86583 6.72126Z",
    stroke: "#00a14b",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.bbafb7ba86015a3c2f4c2302c5bddb96.svg";
export { ForwardRef as ReactComponent };